import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M59.063 26l.03 12.313s-9.233-.126-9.24.187c-.103 5-6.978 9.5-14.024 9.39-11.195-.178-16.017.11-16.017.11l.062 5.938L9.61 43.61l9.975-11.777.04 7.042s13.5.25 13.875.25c.61 0 5.833-.458 8.037-4.903.28-.564.308-1.176 0-2.444-1.204-4.945-8.147-6.11-8.147-6.11H19.976v7.11L9 21.61 19.976 10l-.038 6.688s3.568-.012 15.562.312c9.25.25 13.563 5.938 14.05 9.042.02.144 9.513-.042 9.513-.042z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }